// extracted by mini-css-extract-plugin
export var container = "_6f-0";
export var fallback = "_6f-5";
export var fallbackIcon = "_6f-6";
export var hidden = "_6f-2";
export var image = "_6f-3";
export var loaded = "_6f-4";
export var placeholder = "_6f-1";